import React, { useState } from "react";
import { Icon, Popover, Badge, Tabs, Menu, Dropdown, Row, Col } from "antd";
import "./style.less";
// img
import NoticeImg from "@/assets/image/head/notice.svg";
import MessageImg from "@/assets/image/head/message.svg";
import TodoImg from "@/assets/image/head/todo.svg";
// components
import NoticeItem from "./components/noticeItem";
import MessageItem from "./components/messageItem";
import TodoItem from "./components/todoItem";
// model
import MessageDetails from "../notice/model/messageDetails";
import TodoDetails from "../notice/model/todoDetails";
import NoticeItemModel from "../notice/model/noticeItem";

interface iProps {
  noticeMsg: any;
  changeNoticeTab: (no: string) => void;
  getNumber: () => void;
  getNoticeList: () => void;
  noticeList: NoticeItemModel[];
  messageList: MessageDetails[];
  todoList: TodoDetails[];
  checkAllMessage: () => void;
  mode?: string;
}
const { TabPane } = Tabs;
function Notice(iProps) {
  const {
    noticeList,
    messageList,
    todoList,
    getNoticeList,
    getNumber,
    mode = "dark",
  } = iProps;
  const [visible, setVisible] = useState(false);
  const NoMsg = {
    notice: {
      img: NoticeImg,
      desc: "你已阅完所有通知",
    },
    message: {
      img: MessageImg,
      desc: "你已阅完所有消息",
    },
    todo: {
      img: TodoImg,
      desc: "你已查看所有待办",
    },
  };
  let noticeMsg = iProps.noticeMsg;
  const changeVisible = (visible) => {
    visible && iProps.getNumber();
    setVisible(visible);
  };
  const changeTab = (value) => {
    iProps.changeNoticeTab(value);
  };
  const remarkAllMessage = () => {
    iProps.checkAllMessage();
  };
  // 跳转至查看更多
  const toMore = (type: string) => {
    if (type === "notice")
      window.location.href =
        window.location.origin +
        "/fe-pc/b/bx-mf/fe_notice_user/notice_list";
    else if (type === "message")
      window.location.href =
        window.location.origin + "/fe-pc/b/fe_system_information/message/index";
    else if (type === "todo")
      window.location.href =
        window.location.origin + "/fe-pc/b/fe_system_information/todo/index";
  };
  return (
    <Dropdown
      className="notification-dropdown"
      overlayStyle={{ zIndex: 999 }}
      overlay={
        <Menu>
          <div className="notification-tab">
            <Tabs defaultActiveKey="1" size="small" onChange={changeTab}>
              <TabPane tab={`通知 (${noticeMsg.notice})`} key="1">
                <div className="notification-item">
                  {noticeList && noticeList.length !== 0 && (
                    <div className="notification-datalist">
                      {noticeList.map((item) => {
                        return (
                          <NoticeItem
                            notice={item}
                            getNoticeList={getNoticeList}
                          ></NoticeItem>
                        );
                      })}
                    </div>
                  )}
                  {(!noticeList || noticeList.length === 0) && (
                    <div className="notification-item-noMsg">
                      <div>
                        <img src={NoMsg.notice.img} />
                      </div>
                      <div className="notification-item-noMsg-tip">
                        {NoMsg.notice.desc}
                      </div>
                    </div>
                  )}
                  {(!noticeList || noticeList.length !== 0) && (
                    <div
                      className="checkMore"
                      onClick={toMore.bind(null, "notice")}
                    >
                      查看更多
                    </div>
                  )}
                  {(!noticeList || noticeList.length === 0) && (
                    <div
                      className="checkMore"
                      onClick={toMore.bind(null, "notice")}
                    >
                      查看所有通知
                    </div>
                  )}
                </div>
              </TabPane>
              <TabPane tab={`消息 (${noticeMsg.message})`} key="2">
                <div className="notification-item">
                  {messageList && messageList.length !== 0 && (
                    <div className="notification-datalist">
                      {messageList.map((item) => {
                        return (
                          <MessageItem
                            msg={item}
                            getNoticeList={getNoticeList}
                            getNumber={getNumber}
                          ></MessageItem>
                        );
                      })}
                    </div>
                  )}

                  {(!messageList || messageList.length === 0) && (
                    <div className="notification-item-noMsg">
                      <div>
                        <img src={NoMsg.message.img} />
                      </div>
                      <div className="notification-item-noMsg-tip">
                        {NoMsg.message.desc}
                      </div>
                    </div>
                  )}
                  {(!messageList || messageList.length !== 0) && (
                    <div className="checkMore">
                      <Row>
                        <Col
                          span={12}
                          className="allRead"
                          onClick={remarkAllMessage}
                        >
                          全部已读
                        </Col>
                        <Col
                          span={12}
                          className="more"
                          onClick={toMore.bind(null, "message")}
                        >
                          查看更多
                        </Col>
                      </Row>
                    </div>
                  )}
                  {(!messageList || messageList.length === 0) && (
                    <div className="checkMore">
                      <Row>
                        <Col
                          span={24}
                          className="more"
                          onClick={toMore.bind(null, "message")}
                        >
                          查看所有消息
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>
              </TabPane>
              <TabPane tab={`待办 (${noticeMsg.todo})`} key="3">
                <div className="notification-item">
                  {todoList && todoList.length !== 0 && (
                    <div className="notification-datalist">
                      {todoList.map((item) => {
                        return (
                          <TodoItem
                            todo={item}
                            getNoticeList={getNoticeList}
                            getNumber={getNumber}
                            finishTodo={getNumber}
                          ></TodoItem>
                        );
                      })}
                    </div>
                  )}
                  {(!todoList || todoList.length === 0) && (
                    <div className="notification-item-noMsg">
                      <div>
                        <img src={NoMsg.todo.img} />
                      </div>
                      <div className="notification-item-noMsg-tip">
                        {NoMsg.todo.desc}
                      </div>
                    </div>
                  )}
                  {(!todoList || todoList.length !== 0) && (
                    <div
                      className="checkMore"
                      onClick={toMore.bind(null, "todo")}
                    >
                      查看更多
                    </div>
                  )}
                  {(!todoList || todoList.length === 0) && (
                    <div
                      className="checkMore"
                      onClick={toMore.bind(null, "todo")}
                    >
                      查看所有待办
                    </div>
                  )}
                </div>
              </TabPane>
            </Tabs>
          </div>
        </Menu>
      }
      trigger={["click"]}
      visible={visible}
      onVisibleChange={(visible) => changeVisible(visible)}
    >
      <div
        className={`${
          mode === "dark" ? "notification" : "notification-light"
        }  ${visible ? "selected" : ""}`}
      >
        <Badge
          count={noticeMsg.all > 99 ? "···" : noticeMsg.all}
          style={{ boxShadow: "none" }}
        >
          <Icon
            style={{ color: mode === "dark" ? "#fff" : "#333" }}
            type="mail"
          />
        </Badge>
      </div>
    </Dropdown>
  );
}
export default Notice;
